import React from 'react'
import useIconSize from '../icon-size'
import IconPropTypes from '../IconPropTypes'

function IconWallet({ size, ...props }) {
  const sizeValue = useIconSize(size)
  return (
    <svg
      width={sizeValue}
      height={sizeValue}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 8.577c0-.329.266-.595.595-.595h14.81c.328 0 .595.266.595.595v10.815a.595.595 0 01-.595.595H4.595A.595.595 0 014 19.392V8.577zm1.19.595v9.625h13.62V9.172H5.19z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.033 13.862a2.562 2.562 0 012.562-2.562h3.564c.329 0 .595.266.595.595v3.933a.595.595 0 01-.595.595h-3.564a2.562 2.562 0 01-2.562-2.561zm2.562-1.372a1.371 1.371 0 100 2.743h2.969V12.49h-2.97z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.821 14.65a.778.778 0 100-1.556.778.778 0 000 1.557zm-.359-8.265c.078-.017.167-.04.25-.06l.05-.013a6.67 6.67 0 01.322-.073c.224-.045.413-.06.559-.04.131.02.196.062.242.123.058.076.146.263.146.686a.595.595 0 001.19 0c0-.568-.115-1.044-.384-1.402a1.514 1.514 0 00-1.024-.585c-.345-.05-.689-.004-.96.05a7.8 7.8 0 00-.438.1 6.18 6.18 0 01-.237.057L4.528 7.953a.595.595 0 00.295 1.153l10.639-2.721z"
        clipRule="evenodd"
      />
    </svg>
  )
}

IconWallet.propTypes = IconPropTypes
export default IconWallet
